import { render, staticRenderFns } from "./MobileResults.vue?vue&type=template&id=56cf2dc8"
import script from "./MobileResults.vue?vue&type=script&lang=js"
export * from "./MobileResults.vue?vue&type=script&lang=js"
import style0 from "./MobileResults.vue?vue&type=style&index=0&id=56cf2dc8&prod&lang=css"
import style1 from "./MobileResults.vue?vue&type=style&index=1&id=56cf2dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports